var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"arrow-down__stroke","d":"m11.4 1.5-5.3 5.2-5.2-5.2","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"3"}));
}

ArrowDown.defaultProps = {"className":"arrow-down","height":"8.8","viewBox":"0 0 12.2 8.8","width":"12.2"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
